// client\src\api\axios.js

import axios from 'axios';

// Detecta o hostname correto ou usa localhost como fallback
const apiBaseURL = process.env.REACT_APP_API_BASE_URL || `http://${window.location.hostname || 'localhost'}:4000`;

// console.log('API Base URL:', apiBaseURL); // Adicione para verificar o valor durante o debug

const api = axios.create({
  baseURL: apiBaseURL,
});

// console.log('API Base URL:', api.defaults.baseURL);

export default api;